import React from "react";

export const CloseSVG = ({ fillColor = "#000000", className = "", ...props }) => {
  return (
    <svg
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      // viewPort="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <line x1="1" y1="11"
            x2="11" y2="1"
            stroke="black"
            strokeWidth="2" />
      <line x1="1" y1="1"
            x2="11" y2="11"
            stroke="black"
            strokeWidth="2" />
    </svg>
  );
};
